import React from "react";
import PropTypes from "prop-types";
import injectSheet, { withTheme } from "react-jss";
import { compose } from "recompose";

import { Tipografia, Flex } from "../..";

const style = theme => ({
  tagNovo: {
    margin: [0, 5],
    padding: [0, 10],
    borderRadius: 10,
    backgroundColor: theme.palette.accent1Color,
    width: "max-content",
    display: "inline-flex",
  },
});

const Tag = ({ classes, descricao }) => (
  <Flex center className={classes.tagNovo}>
    <Tipografia style={{ color: "white" }} tipo="notaLegendas">
      {descricao}
    </Tipografia>
  </Flex>
);

Tag.propTypes = {
  /** @ignore */
  classes: PropTypes.object,
  descricao: PropTypes.string,
};

const enhance = compose(
  withTheme,
  injectSheet(style)
);
export default enhance(Tag);
